<div class="card-body">
    {{'Systemreports.replaceyrassetclass.desc'|translate}}
</div>
<div class="card-footer text-right">
    <button type="button" class="btn btn-primary" (click)="openReports()" [attr.aria-label]="''+'Systemreports.btn.generatereport'|translate">{{'Systemreports.btn.generatereport'|translate}}</button>
</div>